import { cloneDeep } from 'lodash'
import { useEffect, useState } from 'react'
import { useGetPaymentTermsQuery } from 'services/paymentTerms'

const usePaymentTerms = ({ getOnlyActive = false }) => {
  const [paymentTermsList, setPaymentTermsList] = useState([])

  const { data: listOfPaymentTerms, isLoading: isLoadingListOfPaymentTerms } = useGetPaymentTermsQuery()

  useEffect(() => {
    if (listOfPaymentTerms) {
      if (listOfPaymentTerms?.length === 0) return setPaymentTermsList([])
      const paymentTermsOptions = getOnlyActive ? listOfPaymentTerms?.filter(term => term.active) : listOfPaymentTerms
      const clonedOptions = cloneDeep(paymentTermsOptions)
      const formattedOptions =
        clonedOptions
          ?.sort((a, b) => (a?.display || '').localeCompare(b?.display || ''))
          ?.map(term => ({ id: term.id, name: term.display })) || []
      setPaymentTermsList(formattedOptions)
    }
  }, [listOfPaymentTerms])

  const dueDateCalculation = (date, paymentTermId) => {
    const dateDue = date ? new Date(date) : new Date()
    const daysToAdd = paymentTermId ? listOfPaymentTerms?.find(term => term.id === paymentTermId)?.days || 0 : 0
    return dateDue.setDate(dateDue.getDate() + daysToAdd)
  }

  const getDueDateFormatted = (date, paymentTermId) => {
    return new Date(dueDateCalculation(date, paymentTermId)).toLocaleDateString('en-US', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    })
  }

  const getPaymentTermNameById = id => {
    if (!id) return undefined
    return paymentTermsList.find(term => term.id === id)?.name || undefined
  }

  const isLoadingPaymentTerms = isLoadingListOfPaymentTerms

  return {
    paymentTermsOptions: paymentTermsList,
    isLoadingPaymentTerms,
    setPaymentTermsOptions: setPaymentTermsList,
    dueDateCalculation,
    getDueDateFormatted,
    getPaymentTermNameById,
  }
}

export default usePaymentTerms
